module.exports = __webpack_public_path__ + "static/img/7.4270465.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/7/1/zh/7.png
// module id = //+1
// module chunks = 0